import './common-cop.scss'

import { COP_COMMON_ERROR_MESSAGES } from '../constants/common-error-messages'
import { ToastService } from '../services/toast.service'
import { AgreementsPermissionsV2 } from '../constants/PermissionsV2'
import { COP_API_BASE_URL, getAgreementExportListUrl } from '../constants/service-endpoints'
import { extractNumberFromUrl } from '../services/agreementNumber'
import { getBlob } from '../services/http.service'
import { fetchPermissionsV2 } from '../services/permissions/permissionsV2.service'

const EXPORT_BUTTON_ID = 'cop-agreement-export'
  ; (function () {
    'use strict'

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init)
    } else {
      init()
    }

    function init() {
      const titleElement = document.getElementById('cop-agreement-details-title')
      appendAgreementIdToRelatedCasesHref()
      initializeAgreementExportDropdown()
      applyAgreementFeaturePermissions()

      if (!titleElement) {
        return
      }
    }

    async function hasAgreementPermission(permissionName: string): Promise<boolean> {
      const customerId = sessionStorage.getItem('cop:customer-id') ?? ''
      if (!customerId) return true
      try {
        const data = await fetchPermissionsV2(customerId)
        return data.permissions.some(p => p.name === permissionName)
      } catch {
        return true
      }
    }

    function hideButtonById(id: string) {
      const el = document.getElementById(id)
      const wrapper = el?.closest('.aem-GridColumn') as HTMLElement | null
      if (wrapper) {
        wrapper.style.display = 'none'
      } else if (el) {
        el.style.display = 'none'
      }
    }

    async function applyAgreementFeaturePermissions() {
      const [canExport, canViewRelatedCases, canViewRelatedSites] = await Promise.all([
        hasAgreementPermission(AgreementsPermissionsV2.ExportDetails),
        hasAgreementPermission(AgreementsPermissionsV2.ViewRelatedCases),
        hasAgreementPermission(AgreementsPermissionsV2.ViewRelatedSites),
      ])

      if (!canExport) {
        hideButtonById(EXPORT_BUTTON_ID)
      }
      if (!canViewRelatedCases) {
        hideButtonById('cop-agreement-related-cases')
      }
      if (!canViewRelatedSites) {
        hideButtonById('list-of-related-sites')
      }
    }

    function getAgreementIdFromUrl() {
      return extractNumberFromUrl()
    }

    async function requestAgreementExport(agreementId: string, exportType: 'Excel' | 'PDF') {
      const url = `${COP_API_BASE_URL}${getAgreementExportListUrl(agreementId, exportType)}`
      return await getBlob(url)
    }

    function triggerFileDownload(fileBlob: Blob, fileName: string) {
      const fileUrl = window.URL.createObjectURL(fileBlob)
      const anchor = document.createElement('a')
      anchor.href = fileUrl
      anchor.setAttribute('download', fileName)
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
      window.setTimeout(function () {
        window.URL.revokeObjectURL(fileUrl)
      }, 0)
    }

    function appendAgreementIdToRelatedCasesHref() {
      const relatedCasesLink = document.getElementById('cop-agreement-related-cases') as HTMLAnchorElement | null
      const agreementId = getAgreementIdFromUrl()

      if (!relatedCasesLink || !agreementId) {
        return
      }

      const gridColumn = relatedCasesLink.parentElement?.parentElement as HTMLElement | null
      if (gridColumn) {
        gridColumn.style.width = '20%'
      }

      const currentHref = relatedCasesLink.getAttribute('href')
      if (!currentHref) {
        return
      }

      if (currentHref.endsWith(`/${agreementId}`) || currentHref === agreementId) {
        return
      }

      const separator = currentHref.endsWith('/') ? '' : '/'
      relatedCasesLink.setAttribute('href', `${currentHref}${separator}${agreementId}`)
    }

    const BUTTON_STYLE = 'display: block; width: 100%; border: none; background: transparent; text-align: left; padding: 8px 24px; line-height: 1.2; color: #262626; cursor: pointer;'
    const DISPLAY_FLEX = 'display: flex'
    const ARROW_DOWN = 'cmp-button__icon--keyboard_arrow_down'
    const ARROW_UP = 'cmp-button__icon--keyboard_arrow_up'
    const ARROW_RIGHT = 'cmp-button__icon--keyboard_arrow_right'

    function initializeAgreementExportDropdown() {
      const exportLink = document.getElementById(EXPORT_BUTTON_ID) as HTMLAnchorElement | null

      const arrowIcon = exportLink?.querySelector(
        '.cmp-button__icon--keyboard_arrow_right, .cmp-button__icon--keyboard_arrow_down, .cmp-button__icon--keyboard_arrow_up',
      ) as HTMLElement | null

      const exportText = exportLink?.querySelector('.cmp-button__text') as HTMLElement | null
      const linkIcon = exportLink?.querySelector('.icon-link') as HTMLElement | null

      if (!exportLink) {
        return
      }

      if (arrowIcon && exportText && exportText.parentElement) {
        exportText.insertAdjacentElement('afterend', arrowIcon)
      }

      const exportContainer = exportLink.parentElement

      if (!exportContainer) {
        return
      }

      if (exportLink.dataset.dropdownInitialized === 'true') {
        return
      }

      exportLink.dataset.dropdownInitialized = 'true'

      exportContainer.setAttribute('style', 'position: relative; display: inline-block;')

      exportLink.setAttribute(
        'style',
        `${DISPLAY_FLEX}; align-items: center; background: #fff; text-decoration: none;`,
      )

      if (exportText) {
        exportText.style.fontWeight = '700'
      }

      if (linkIcon) {
        linkIcon.style.display = 'none'
      }

      if (arrowIcon) {
        arrowIcon.classList.remove(ARROW_RIGHT)
        arrowIcon.classList.remove(ARROW_UP)
        arrowIcon.classList.add(ARROW_DOWN)
        arrowIcon.style.marginLeft = '14px'
      }

      let dropdownWrapper = exportContainer.querySelector(
        '.cop-agreement-export-dropdown',
      ) as HTMLDivElement | null

      if (!dropdownWrapper) {
        dropdownWrapper = document.createElement('div')
        dropdownWrapper.className = 'cop-agreement-export-dropdown'

        dropdownWrapper.setAttribute('data-export-id', EXPORT_BUTTON_ID)


        dropdownWrapper.setAttribute(
          'style',
          `position: absolute; top: calc(100% + 4px); right: 0px; z-index: 100; background-color: rgb(255, 255, 255); border: 1px solid rgb(209, 213, 219); border-radius: 6px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; min-width: 168px; list-style: none; margin: 0px; padding: 6px 0px; display: none;`,
        )

        dropdownWrapper.setAttribute('role', 'menu')
        dropdownWrapper.setAttribute('aria-label', 'Export agreement as')

        const excelOption = document.createElement('button')
        excelOption.type = 'button'
        excelOption.textContent = 'Excel'
        excelOption.setAttribute('style', BUTTON_STYLE)

        const pdfOption = document.createElement('button')
        pdfOption.type = 'button'
        pdfOption.textContent = 'PDF'
        pdfOption.setAttribute('style', BUTTON_STYLE)

        excelOption.addEventListener('click', async function () {
          await handleAgreementExportSelection('excel')
          hideDropdown()
        })

        pdfOption.addEventListener('click', async function () {
          await handleAgreementExportSelection('pdf')
          hideDropdown()
        })

        dropdownWrapper.appendChild(excelOption)
        dropdownWrapper.appendChild(pdfOption)

        exportLink.insertAdjacentElement('afterend', dropdownWrapper)
      }

      function showDropdown() {
        if (!dropdownWrapper) {
          return
        }

        dropdownWrapper.style.display = 'block'

        if (arrowIcon) {
          arrowIcon.classList.remove(ARROW_DOWN)
          arrowIcon.classList.add(ARROW_UP)
        }
      }

      function hideDropdown() {
        if (!dropdownWrapper) {
          return
        }

        dropdownWrapper.style.display = 'none'

        if (arrowIcon) {
          arrowIcon.classList.remove(ARROW_UP)
          arrowIcon.classList.add(ARROW_DOWN)
        }
      }

      function toggleDropdown() {
        if (!dropdownWrapper) {
          return
        }

        const isOpen = dropdownWrapper.style.display === 'block'

        if (isOpen) {
          hideDropdown()
        } else {
          showDropdown()
        }
      }

      exportLink.addEventListener('click', function (event) {
        event.preventDefault()
        event.stopPropagation()

        toggleDropdown()
      })

      document.addEventListener('click', function (event) {
        const clickedInside = exportContainer.contains(event.target as Node)

        if (!clickedInside) {
          hideDropdown()
        }
      })
    }

    async function handleAgreementExportSelection(selectedFormat: 'excel' | 'pdf') {
      const agreementId = getAgreementIdFromUrl()
      if (!agreementId) {
        return
      }

      try {
        const exportType = selectedFormat === 'excel' ? 'Excel' : 'PDF'
        const fileBlob = await requestAgreementExport(agreementId, exportType)
        const fileName = selectedFormat === 'excel' ? 'sites-list-for-agreement.xlsx' : 'sites-list-for-agreement.pdf'
        triggerFileDownload(fileBlob, fileName)
      } catch (error) {
        const exportTypeLabel = selectedFormat === 'excel' ? 'Excel' : 'PDF'
        const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].action['export-failed'].replace('{{exportType}}', exportTypeLabel)
        const message = error instanceof Error && error.message ? error.message : fallbackMessage
        ToastService.error(message)
      }
    }

  })()
